import { bbox } from "@turf/turf";
import { Basemap } from "components/basemap/basemap";
import { useRef } from "react";
import { Layer, LayerProps, MapRef, Source } from "react-map-gl/maplibre";

// The stored outline (GeoJSON geometry text) as a collection for the map.
export function thumbnailCollection(
  thumbnail: string | undefined,
): GeoJSON.FeatureCollection | undefined {
  if (!thumbnail) return undefined;
  return {
    type: "FeatureCollection",
    features: [
      { type: "Feature", properties: {}, geometry: JSON.parse(thumbnail) },
    ],
  };
}

interface MapThumbnailProps {
  geometry?: GeoJSON.FeatureCollection;
  // Replaces the list's 100 px rounded-left box, e.g. to fill a card.
  style?: React.CSSProperties;
}
export const MapThumbnail = (props: MapThumbnailProps) => {
  const mapRef = useRef<MapRef>();

  const shape = props.geometry;
  const [minLng, minLat, maxLng, maxLat] = shape
    ? bbox(shape)
    : // bounding box of Australia
      [96, -45, 168, -8];

  const dataLayer: LayerProps = {
    id: "data",
    type: "fill",
    paint: {
      "fill-color": "#00ffff",
      "fill-opacity": 0.8,
    },
  };

  return (
    <Basemap
      // @ts-ignore
      mapRef={mapRef}
      attributionControl={false}
      onZoom={(zoom) => {}}
      style={props.style ?? {
        width: "100px",
        height: "100px",
        borderTopLeftRadius: "15px",
        borderBottomLeftRadius: "15px",
        borderTopRightRadius: "0px",
        borderBottomRightRadius: "0px",
        boxShadow: "none",
        border: "none",
      }}
      interactive={false}
      bbox={[minLng, minLat, maxLng, maxLat]}
      bboxPadding={20}
    >
      {shape && (
        <Source type="geojson" data={shape}>
          <Layer {...dataLayer} />
        </Source>
      )}
    </Basemap>
  );
};
